export default __webpack_public_path__ + "static/media/010_photo.77b6257e.jpg";